import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/head-teacher/rating-teacher",
  },
  actions: {
    // O'qituvchilar ro'yxatini olish
    getTeachers({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/teachers?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    // O'qituvchi uchun oylik baholarni olish
    getTeacherRatings({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/ratings?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    // O'qituvchiga baho qo'shish
    addRating({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/rating`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    // O'qituvchi bahosini yangilash
    updateRating({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/rating`,
          method: "PUT",
          data,
        },
        { root: true }
      );
    },
  },
};
